import type { UserDataType } from '@/src/context/types'
import type { AppDispatch } from '@/src/store'
import { fetchCurrentUser } from '@/src/store/apps/resto365UserManagement'
import { setDatadogUser } from '@/src/observability/datadog'
import { mapRestoUserToAuthUser } from '@/src/@core/utils/map-resto-user-to-auth-user'
import oktaAuth from '@/src/services/okta'

/**
 * Fetches `resto365-user/me` and updates `AuthContext` when the response matches the logged-in user.
 * Used after permission-affecting changes (e.g. role save) so `AclGuard` sees fresh permissions without a full reload.
 */
export async function refetchCurrentUserAndSyncAuth(
  dispatch: AppDispatch,
  setUser: (value: UserDataType | null) => void,
  currentAuthUserId: number | undefined
): Promise<void> {
  if (currentAuthUserId === undefined) {
    return
  }

  try {
    const me = await dispatch(fetchCurrentUser()).unwrap()
    if (!me || me.id !== currentAuthUserId) {
      return
    }

    let stillAuthenticated = false
    try {
      stillAuthenticated = await oktaAuth.isAuthenticated()
    } catch {
      return
    }
    if (!stillAuthenticated) {
      return
    }

    setUser(mapRestoUserToAuthUser(me))
    setDatadogUser({ id: me.id, email: me.email, name: me.name })
  } catch {
    // Keep existing session if /me fails (network, etc.)
  }
}
